import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, PieChart, Pie, Cell, Legend } from "recharts";

const COLORS = ["#C9A864", "#b59556", "#F4F0EB", "#8c7244", "#5e4a2a"];

export default function AdminAnalytics() {
  const [data, setData] = useState(null);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/admin/dashboard").then((r) => setData(r.data));
    api.get("/products").then((r) => setProducts(r.data || []));
  }, []);

  if (!data) return <div className="p-10 text-white/40 tracking-luxury uppercase text-sm">Loading…</div>;

  const byCategory = Object.entries(
    products.reduce((acc, p) => ({ ...acc, [p.category]: (acc[p.category] || 0) + 1 }), {})
  ).map(([name, value]) => ({ name, value }));

  return (
    <div className="p-8 md:p-12" data-testid="admin-analytics">
      <header className="mb-8">
        <p className="text-[11px] tracking-luxury uppercase text-poche-gold">Atelier</p>
        <h1 className="font-serif text-5xl mt-2">Analytics</h1>
      </header>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="bg-poche-ink border border-white/10 p-6">
          <h3 className="text-[11px] tracking-luxury uppercase text-poche-gold mb-6">Revenue Trend · 7 days</h3>
          <div style={{ width: "100%", height: 280 }}>
            <ResponsiveContainer>
              <BarChart data={data.revenue_series}>
                <XAxis dataKey="date" tick={{ fill: "#aaa", fontSize: 10 }} axisLine={false} tickLine={false} />
                <YAxis tick={{ fill: "#aaa", fontSize: 10 }} axisLine={false} tickLine={false} />
                <Tooltip contentStyle={{ background: "#0A0A0A", border: "1px solid rgba(201,168,100,0.3)", borderRadius: 0 }} cursor={{ fill: "rgba(201,168,100,0.08)" }} />
                <Bar dataKey="revenue" fill="#C9A864" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="bg-poche-ink border border-white/10 p-6">
          <h3 className="text-[11px] tracking-luxury uppercase text-poche-gold mb-6">Catalog · By Category</h3>
          <div style={{ width: "100%", height: 280 }}>
            <ResponsiveContainer>
              <PieChart>
                <Pie data={byCategory} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={100} stroke="#0A0A0A">
                  {byCategory.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
                <Legend wrapperStyle={{ fontSize: 10, color: "#aaa", textTransform: "uppercase", letterSpacing: "0.2em" }} />
                <Tooltip contentStyle={{ background: "#0A0A0A", border: "1px solid rgba(201,168,100,0.3)", borderRadius: 0 }} />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-poche-gold/15 mt-8">
        {[
          ["Avg Order Value", `$${(data.total_revenue / Math.max(data.total_orders, 1)).toFixed(2)}`],
          ["Conversion", `${data.total_orders === 0 ? "0.0" : ((data.total_orders / Math.max(data.total_customers, 1)) * 100).toFixed(1)}%`],
          ["Catalog Size", data.total_products],
          ["Legacy Pipeline", data.legacy_pending],
        ].map(([l, v], i) => (
          <div key={i} className="bg-poche-ink p-6">
            <div className="text-[10px] tracking-luxury uppercase text-white/45">{l}</div>
            <div className="font-serif text-3xl text-poche-gold mt-2">{v}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
